const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/server/app-render/work-async-storage.external.js");